import api from './api';
import Product, { ProductInterface } from './product';
import { CardMedia, CustomizerMedia, BackgroundMedia } from '@/utils/types';
import ProductPage, { ProductPageInterface } from './product-page';

export interface ProductTypeInterface {
    id: number;
    name: string;
    position: number;
    slug: string;
    products?: ProductInterface[];
    order_flow_id: number;
    is_active: boolean;
    is_customisable: boolean;
    custom_price: number | string;
    plural_name: string;
    singular_name: string;
    image: CardMedia & CustomizerMedia;
    background: BackgroundMedia | null;
    printers: [];
    product_pages: ProductPageInterface[];
}

export default class ProductType implements ProductTypeInterface {
    id: number;
    name: string;
    position: number;
    slug: string;
    products?: Product[];
    order_flow_id: number;
    is_active: boolean;
    is_customisable: boolean;
    custom_price: number;
    plural_name: string;
    product_pages: ProductPage[];
    singular_name: string;
    image: CardMedia & CustomizerMedia;
    background: BackgroundMedia | null;
    printers: [];

    constructor(productType: ProductTypeInterface) {
        this.id = productType.id;
        this.name = productType.name;
        this.position = productType.position;
        this.slug = productType.slug;
        this.is_active = productType.is_active;
        this.is_customisable = productType.is_customisable;
        this.custom_price = parseFloat(<string>productType.custom_price);
        this.plural_name = productType.plural_name;
        this.singular_name = productType.singular_name;
        this.image = productType.image;
        this.background = productType.background;
        this.printers = productType.printers;
        this.product_pages = productType.product_pages;
        this.order_flow_id = productType.order_flow_id;
        if (productType.products !== undefined) {
            this.products = Product.createBatch(productType.products);
        }
    }

    static async find(id: number): Promise<ProductType | null> {
        const response = await api.get<ProductTypeInterface>({ name: 'product_type.show', parameters: { id } });
        if (response.success) {
            return new ProductType(response.content as ProductTypeInterface);
        }
        return null;
    }

    static async findBySlug(slug: string): Promise<ProductType | null> {
        const response = await api.get<ProductTypeInterface>({ name: 'product_type.find', parameters: { slug } });
        if (response.success) {
            return new ProductType(response.content as ProductTypeInterface);
        }
        return null;
    }

    static async getProductPages(id: number): Promise<ProductPage[] | null> {
        const response = await api.get<ProductPageInterface[]>({ name: 'product_type.pages', parameters: { id } });
        if (response.success) {
            return ProductPage.createBatch(response.content as ProductPageInterface[]);
        }
        return null;
    }
}
